/** Sparkle glyph flanking the Lowest Price Assurance heading. */
export function LowestPriceAssuranceSparkle() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
      <path d="M7.5 3.99999C5.27556 4.71622 4.54225 5.51371 4 7.5C3.45775 5.51371 2.72445 4.71622 0.5 3.99999C2.72445 3.2838 3.45775 2.48631 4 0.5C4.54225 2.48631 5.27556 3.2838 7.5 3.99999Z" stroke="#4D1C0B" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

/** Soft divider line beside the Lowest Price Assurance heading. */
export function LowestPriceAssuranceSideLine() {
  return (
    <span className='flex min-w-4 flex-1 items-center' aria-hidden='true'>
      <svg width="345" height="2" viewBox="0 0 345 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill='var(--ep-plus-line)' d="M173.418 0C224.878 0.00666674 276.349 0.447743 327.764 1.39551C333.54 1.5041 339.291 1.61941 345 1.75C339.289 1.71992 333.538 1.69982 327.761 1.68164C276.339 1.54282 224.873 1.50658 173.418 1.5H173.401C121.334 1.50679 69.2824 1.54839 17.2305 1.68457C11.4674 1.70201 5.70247 1.72149 0 1.75C5.70116 1.62203 11.4652 1.50838 17.2275 1.40137C69.2728 0.454273 121.328 0.00678909 173.401 0H173.418Z" fill="#81594A" />
      </svg>
    </span>
  )
}

